import type { Phrases } from '../common/Phrases.d';

import React from 'react';
import { Span, cn } from '../../../components/Element';
import { TextField } from '../../../components/react-hook-form/TextField';
import { SERVICES_FIELD_NAME } from './constants';


export const MobileNumberTextField = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const label = phrases['notificationForm.services.mobileNumberField.label'];
	return (
		<TextField
			autoComplete='tel'
			className={cn({ flexGrow: 1 })}
			errorSummaryLabel={label}
			fullWidth
			label={<Span textSize='lg'>{label}</Span>}
			name={SERVICES_FIELD_NAME.MOBILE_NUMBER}
			type='tel'
		/>
	);
};
